import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSectionList = () => {
  const [loading, setLoading] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getSectionList = params => {
    if (!params?.guid) return;
    setLoading(true);

    axiosClient
      .get(`/InventoryAgent/AccessibleSection`, {
        params: { Guid: params.guid },
      })
      .then(res => {
        if (res.status === 200) {
          const value = res.data.value;
          setpageRef(value);
          const list = Array.isArray(value) ? value : value?.list || [];
          const orderedList = list.map((element, index) => ({
            guid: element.guid,
            order: element.order ?? index + 1,
            display: element.display,
          }));
          setSectionList(orderedList);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getSectionList, loading, sectionList, pageRef];
};

export default useSectionList;
